import syncProcessListener from './syncProcessListener';
import { getterTypes } from '../../../types';
import { PACKAGE_SYNCER_MODES, PACKAGE_SYNCER_STATE } from '../../../tools/consts';
import actions from './actions';
import mutations from './mutations';

export default {
	state: {
		isActive: false,
		isSyncing: false,
		mode: PACKAGE_SYNCER_MODES.all,
		subParts: {},
		actionQueue: [],
		currentAction: null, // { subPartID, action } action deleting, uploading
		packagesInstalled: [],
		packagesGoal: [],
		packagesProcessed: 0,
		packagesTotal: 0,
		errors: [],
		initialPackages: [],
	},
	getters: {
		progress(state) {
			return state.packagesTotal > 0
				? Math.round((100 * state.packagesProcessed) / state.packagesTotal)
				: undefined;
		},
		[getterTypes.packageSyncerPartState]: state => id => {
			const subPart = state.subParts[id];
			if (!subPart) return undefined;
			if (state.currentAction && state.currentAction.subPartID === id) {
				return PACKAGE_SYNCER_STATE.downloading;
			}
			if (state.actionQueue.find(({ subPartID }) => subPartID === id)) return PACKAGE_SYNCER_STATE.waiting;
			if (subPart && subPart.packagesGoal.length === subPart.packagesInstalled.length && subPart.isSelected)
				return PACKAGE_SYNCER_STATE.downloaded;
			return PACKAGE_SYNCER_STATE.notDownloaded;
		},
	},
	mutations,
	actions,
	plugins: [syncProcessListener],
};
